import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/app";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function GoogleButton({ label }) {
  return (
    <button type="button" data-testid="google-login-btn" onClick={startGoogleLogin}
      className="flex w-full items-center justify-center gap-3 rounded-full border border-slate-200 bg-white py-3 text-sm font-semibold text-slate-800 transition-colors hover:border-slate-400">
      <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6C12.3 13.6 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z"/><path fill="#FBBC05" d="M10.4 28.8A14.5 14.5 0 0 1 9.5 24c0-1.7.3-3.3.8-4.8l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.8-6z"/><path fill="#34A853" d="M24 48c6.2 0 11.6-2 15.4-5.6l-7.5-5.8c-2.1 1.4-4.8 2.3-7.9 2.3-6.3 0-11.7-4.1-13.6-9.9l-7.8 6C6.5 42.6 14.6 48 24 48z"/></svg>
      {label}
    </button>
  );
}

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { applyAuth } = useAuth();
  const done = useRef(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    api.post("/auth/google/session", { session_id: sid })
      .then(async ({ data }) => { await applyAuth(data); window.history.replaceState(null, "", "/app"); nav("/app", { replace: true }); })
      .catch((e) => setErr(errMsg(e)));
  }, []); // eslint-disable-line
  return (
    <div className="mo-grid-bg flex min-h-screen flex-col items-center justify-center gap-4">
      <Logo />
      <p data-testid="auth-callback-status" className="text-sm text-slate-600">{err || "Accesso con Google in corso..."}</p>
      {err && <a href="/login" className="text-sm font-semibold text-[#4a8a56]">Torna al login</a>}
    </div>
  );
}
